import React from 'react';
import LegalLayout from './LegalLayout';

export default function PrivacyPolicy({ isDark }) {
    return (
        <LegalLayout title="Privacy Policy" lastUpdated="May 28, 2026" isDark={isDark}>
            <div className="space-y-6 text-sm leading-relaxed">
                <section>
                    <h2 className="text-xl font-bold mt-8 mb-4">1. Information We Collect</h2>
                    <p>When you sign up, we collect your first name, last name, email address, and organization details. We utilize Google Firebase to securely manage your identity, which generates a unique ID. We process payments via Stripe. For platform security, our system automatically records an audit log of your actions within the Service.</p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mt-8 mb-4">2. How We Use Your Information</h2>
                    <p>We process your personal data to provision and isolate your cloud data warehouse infrastructure on Google Cloud Platform (GCP), authenticate your login credentials, monitor system health, and process recurring subscription payments.</p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mt-8 mb-4">3. European (GDPR) and California (CCPA) Privacy Rights</h2>
                    <p>If you are located in the European Economic Area (EEA), the UK, or California, you have the Right to Access, Right to Erasure / Deletion, and Right to Portability regarding your personal data.</p>
                </section>
            </div>
        </LegalLayout>
    );
}